module.exports = "/_next/static/images/plus-8151f005e22042aa82d42151b666bdf5.svg";